import {ExportStatus, useChargesExportQuery} from 'api/generated';
import {useEffect} from 'react';

export const useCheckExportStatus = (exportId: string) => {
  const {data, loading, error, startPolling, stopPolling} = useChargesExportQuery({
    variables: {
      id: exportId
    },
    skip: !exportId
  });

  useEffect(() => {
    if (exportId) {
      startPolling(5000);
    }
    if (error || data?.chargesExport?.status !== ExportStatus.PENDING) {
      stopPolling();
    }
    return () => {
      stopPolling();
    };
  }, [exportId, startPolling, stopPolling, error, data]);
  return {data, loading, error};
};
